import { DocumentServicesObject, CompRef } from '@wix/document-services-types';
import { EventType } from '@wix/editor-platform-sdk-types';
import { ComponentsPlatformService } from '@wix/editor-platform-manifest-services';
import { parseHostEvent } from './utils';
import { appRefreshCompleted } from '../viewStateService/events/appRefreshCompleted';

export function initStateResetHandler(
  documentServicesAPI: DocumentServicesObject,
  componentsPlatformService: ComponentsPlatformService,
) {
  let shouldSkipSelectionChangedEvent = false;

  documentServicesAPI.platform.subscribeOnCustomAppEvents((event) => {
    const hostEvent = parseHostEvent<{ componentRefs: CompRef[] }>(event);
    const eventType = hostEvent.eventType;

    switch (eventType) {
      case EventType.componentSelectionChanged:
        if (!hostEvent.componentRefs?.length) {
          break;
        }

        if (shouldSkipSelectionChangedEvent) {
          shouldSkipSelectionChangedEvent = false;
          return;
        }

        componentsPlatformService.states.reconcileStatesOnComponentSelection(
          hostEvent.componentRefs,
        );
        break;

      case EventType.appRefreshCompleted:
        appRefreshCompleted(documentServicesAPI);
        shouldSkipSelectionChangedEvent = true;
        break;
    }
  });
}
